<!-- This is the parent to other navigation related components. -->
<template>
<div></div>
</template>

<script>

export default {
  name: 'NavigationItem',
  props: ['route'],
  computed: {
    url () {
      return this.route.path.replace('?', '')
    },
    title () {
      return this.route.name
    },
    icon () {
      if (this.route.meta && this.route.meta.icon) {
        return this.route.meta.icon
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped>
</style>
